import { useState, useEffect, React } from "react";
import { useDispatch, useSelector } from "react-redux";
import api from "../../utils/api";
// import { StarIcon } from "@material-ui/icons/Star";
import { useParams } from "react-router-dom";
import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardHeader,
  CardMedia,
  Grid,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";

import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";
import CallIcon from "@mui/icons-material/Call";
import HomeIcon from "@mui/icons-material/Home";
import CategoryIcon from "@mui/icons-material/Category";
import StarIcon from "@mui/icons-material/Star";
const HostelDetails = () => {
  const [hostel, setHostel] = useState({});
  const userstate = useSelector((state) => state.loginUserReducer);
  const { currentUser } = userstate;
  const params = useParams();
  const [hostelRating, setHostelRating] = useState(0);
  const [hostelRatingCount, setHostelRatingCount] = useState(0);
  const [isAlreadyReviewed, setIsAlreadyReviewed] = useState(false);

  useEffect(() => {
    api
      .get(`/hostels/by-id/${params?.hostelId}`)
      .then((res) => {
        console.log("hostel>", res.data);
        setHostel(res.data);
      })
      .catch((err) => console.log(err));
  }, []);
  const [rating, setRating] = useState(0);
  const navigate = useNavigate();
  const submitRating = (id) => {
    console.log("rating>", rating, id);
    if (rating !== 0) {
      const body = {
        userId: currentUser?.id,
        hostelId: hostel?._id,
        rating: rating,
      };
      api
        .post("/hostels/submit-rating", body)
        .then((res) => {
          console.log("res>", res.data);
          let notifBody = {
            userId: currentUser?.id,
            text: `${currentUser?.name} gives your hostel upload a ${rating} star rating.`,
            forAll: false,
            receiverId: hostel?.userId,
          };
          api.post("/notifications", notifBody).then((re) => {
            console.log("notif", re.data);
            window.location.reload();
          });
          window.location.reload();
        })
        .catch((err) => console.log(err));
      setRating(0);
    }
  };
  useEffect(() => {
    api
      .get(`/hostels/ratings/${params?.hostelId}`)
      .then((res) => {
        console.log("hostel ratings", res.data);
        console.log("user id>", currentUser?.id);
        if (res.data.length > 0) {
          let total = 0;
          let count = 0;
          res.data.map((r) => {
            console.log("not equal");
            if (r.userId == currentUser?.id) {
              console.log("are equal");
              setIsAlreadyReviewed(true);
            }
            total = total + r.rating;
            count++;
          });
          setHostelRating(total / count);
          console.log("hostel rating", total);
          setHostelRatingCount(count);
        }
      })
      .catch((err) => console.log);
  }, []);
  const deleteHostel = (h) => {
    console.log("hostel", hostel);
    api
      .delete(`/hostels/${h?._id}`)
      .then((res) => {
        if (res.data) {
          let notifBody = {
            userId: currentUser?.id,
            text: `Admin delete your hostel for violating terms and conditions.`,
            forAll: false,
            receiverId: h?.userId,
          };
          api
            .post("/notifications", notifBody)
            .then((re) => console.log("notif", re.data));
          window.location.reload();
        }
      })
      .catch((err) => console.log);
  };
  return (
    <Box className="container">
      <Box>
        <Typography
          variant="h4"
          sx={{ fontWeight: "600", color: "fontPrimaryColor.main" }}
        >
          {hostel?.generalData?.hostelName}
        </Typography>
      </Box>
      <Box sx={{ width: { md: "70%", xs: "90%" } }}>
        <Carousel>
          {hostel?.hostelImages?.map((slideImage, index) => (
            <Box key={index} sx={{ marginTop: "30px" }}>
              <img src={slideImage} style={{ width: "100%", height: "auto" }} />
            </Box>
          ))}
        </Carousel>
      </Box>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "10px" }}>
        <Box sx={{ display: "flex", gap: "15px" }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", width: "120px" }}
          >
            <CallIcon /> Contact No.{" "}
          </Typography>
          <Typography variant="body" sx={{ color: "colorThree.main" }}>
            {hostel?.generalData?.contact}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", gap: "15px" }}>
          <Typography
            variant="body2"
            sx={{ fontWeight: "600", width: "120px" }}
          >
            <HomeIcon /> Address{" "}
          </Typography>
          <Typography variant="body" sx={{ color: "colorThree.main" }}>
            {hostel?.generalData?.hostelAddress}
          </Typography>
        </Box>
      </Box>
      <Box
        className="row"
        sx={{
          borderTop: "1px dashed lightgray",
          borderBottom: "1px dashed lightgray",
          margin: "30px 0",
          display: "flex",
          padding: "20px ",
        }}
      >
        <Box sx={{ display: "flex", flex: "0.5", gap: "5px" }}>
          <Box>
            <StarIcon sx={{ fontSize: "2rem", color: "colorThree.main" }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "0.8rem", color: "#0c0c0c" }}>
              Rating
            </Typography>
            <Typography>
              {hostelRating ? ` ${hostelRating} (${hostelRatingCount})` : "N/A"}
            </Typography>
          </Box>
        </Box>
        <Box sx={{ display: "flex", flex: "0.5", gap: "5px" }}>
          {" "}
          <Box>
            <CategoryIcon sx={{ fontSize: "2rem", color: "colorThree.main" }} />
          </Box>
          <Box>
            <Typography sx={{ fontSize: "0.8rem", color: "#0c0c0c" }}>
              Category
            </Typography>
            <Typography>{hostel?.generalData?.hostelCategory}</Typography>
          </Box>
        </Box>
      </Box>
      <Box>
        <Typography variant="h5" sx={{ fontWeight: "600" }}>
          Facilities
        </Typography>
        <Grid container sx={{ display: "flex", marginTop: "20px" }}>
          {hostel?.facilities?.map((f) => (
            <Grid xs={6} sm={3}>
              <Typography
                variant="h6"
                sx={{
                  width: "max-content",
                  padding: "2px 4px",
                  margin: "3px",
                  color: "colorThree.main",
                }}
              >
                {f}
              </Typography>
            </Grid>
          ))}
        </Grid>
      </Box>
      <Box sx={{ marginTop: "20px" }}>
        <Typography
          variant="h5"
          sx={{ fontWeight: "600", marginBottom: "10px" }}
        >
          Hostel Details
        </Typography>
        <Typography
          variant="p"
          sx={{ marginTop: "15px", color: "fontPrimaryColor.main" }}
        >
          {hostel?.generalData?.hostelDetails}
        </Typography>
      </Box>
      <Box
        sx={{
          marginTop: "20px",
          borderTop: "1px dashed lightgray",
          padding: "30px 0",
          display: "flex",
          flexDirection: "column",
          gap: "20px",
        }}
      >
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Estimated Rent
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.estimatedRent}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Bills Included
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.billsIncluded}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Rent Period
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.rentPeriod}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Hostel Condition
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.hostelCondition}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Members per room
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.membersPerRoom}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>
            Number of rooms
          </Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.numberOfRooms}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>City</Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.city}
          </Typography>
        </Box>
        <Box sx={{ display: "flex" }}>
          <Typography sx={{ flex: "0.3", fontWeight: "600" }}>State</Typography>
          <Typography sx={{ flex: "0.3" }}>
            {hostel?.generalData?.state}
          </Typography>
        </Box>
      </Box>

      <a href={hostel?.generalData?.hostelLocationLink} target="_blank">
        See Live Location
      </a>
      <Box
        className="tags bg-white mt-3 mb-3"
        sx={{ width: "max-content", marginBottom: "40px" }}
      >
        {hostel?.tags?.map((t) => (
          <Typography className="tag-span">{t}</Typography>
        ))}
      </Box>
      <Box sx={{ marginTop: "30px" }}>
        {currentUser?.isAdmin ? (
          <button
            className=" asc__submit__form__button"
            onClick={() => deleteHostel(hostel)}
          >
            Delete Hostel
          </button>
        ) : (
          <>
            {hostel?.userId !== currentUser?.id && (
              <>
                {isAlreadyReviewed ? (
                  <Typography variant="body2" color="gray">
                    rating given
                  </Typography>
                ) : (
                  <Box
                    className=" row m-0 mt-3"
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexDirection: "row",
                    }}
                  >
                    <Box className={"col-6 rating__wrapper"}>
                      <Typography
                        variant="body2"
                        sx={{ textDecoration: "underline" }}
                      >
                        Rate it{" "}
                      </Typography>
                      <Box className="rating__stars">
                        <span
                          onClick={() => setRating(1)}
                          className={
                            (rating === 1 && "shine") ||
                            (rating === 2 && "shine") ||
                            (rating === 3 && "shine") ||
                            (rating === 4 && "shine") ||
                            (rating === 5 && "shine")
                          }
                        >
                          <StarIcon />
                        </span>
                        <span
                          onClick={() => setRating(2)}
                          className={
                            (rating === 2 && "shine") ||
                            (rating === 3 && "shine") ||
                            (rating === 4 && "shine") ||
                            (rating === 5 && "shine")
                          }
                        >
                          <StarIcon />
                        </span>
                        <span
                          onClick={() => setRating(3)}
                          className={
                            (rating === 3 && "shine") ||
                            (rating === 4 && "shine") ||
                            (rating === 5 && "shine")
                          }
                        >
                          <StarIcon />
                        </span>
                        <span
                          onClick={() => setRating(4)}
                          className={
                            (rating === 4 && "shine") ||
                            (rating === 5 && "shine")
                          }
                        >
                          <StarIcon />
                        </span>
                        <span
                          onClick={() => setRating(5)}
                          className={rating === 5 && "shine"}
                        >
                          <StarIcon />
                        </span>
                      </Box>
                    </Box>
                    <Box
                      className="col-6 "
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "-10px",
                      }}
                    >
                      <button
                        className="asc__submit__form__button"
                        onClick={() => submitRating(hostel?._id)}
                        sx={{ marginTop: "-10px" }}
                      >
                        <span className="fa fa-send"></span> submit rating
                      </button>
                    </Box>
                  </Box>
                )}
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  );
};

export default HostelDetails;
